/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
		scrollTop: 0,
    // All pages
    'common': {
      init: function() {
				// JavaScript to be fired on all pages

				$(".share-link").click(function(e){
					e.preventDefault();
					var top = ( screen.height / 2 ) - ( 600 / 2 );
					var left = ( screen.width / 2 ) - ( 600 / 2 );
					window.open( $(this).attr("href"), "", "location=no,width=600,height=600,top="+top+",left="+left );
				});

				// $(window).scroll(function(){
				// 	var pageScroll = $(this).scrollTop();
				// 	$(".animate-in").each(function(){
				// 		var topP = $(this).offset().top - pageScroll + 25;
        //     if( topP < $(window).innerHeight() ){
        //       $(this).addClass("in");
        //     }
				// 	});
				// }).scroll();

				$(".carousel-benevole").on("slide.bs.carousel", UTIL.carousel_slide);
				$(".carousel-benevole").on("slid.bs.carousel", UTIL.carousel_slid);

				YTdeferred.done(function(YT) {
          $(".yt-player").each(function(){
            player = new YT.Player( this, {
              videoId: $(this).data("video"),
              events: {
								onReady: UTIL.YTReady,
                onStateChange: UTIL.YTStateChange
              },
              playerVars: {
                color: 'white',
                modestbranding: 1,
                controls: 0,
                fs: 0,
                rel: 0,
                showinfo: 0
              }
            } );
          });
				});

				$(".ajax-more").click(function(e){
          e.preventDefault();
          var url = $(this).data("url");
          var $target = $(this).data("target");
          var $button = $(this);
					var page = $(this).data("page");
					var search = $(this).data("search");
					// var cat = $(this).data("cat");
					var type = $(this).data("type");
          if( !$button.hasClass("is-loading") ){
            $.ajax({
              url: url,
              data: {
                action: "loadmore",
                page: page,
								type: type,
								search: search
              },
              beforeSend: function(){
                $button.addClass("is-loading");
              },
              success: function( data, status ){
                if( data !== "false" ){
                  $button.closest(".container").before(data);
                  page++;
                  if( $(data).find("article").length >= 10 ){
                    $(".ajax-more").data("page", page);
                  }else{
                    $(".ajax-more").remove();
                  }
                }else{
                  $(".ajax-more").remove();
                }
              },
              complete: function(){
                setTimeout(function(){
                  // $(".ajaxed").removeClass("ajaxed");
                  $(window).scroll();
                  $button.removeClass("is-loading");
                }, 100);
              }
            });
          }
				});

				$(".navbar-toggler").click(function(e){
					e.preventDefault();
					var $target = $( $(this).data( "target" ) );
					$(this).toggleClass("collapsed");
					$target.toggleClass("show");
					$target.find( ".sub-open, .open" ).removeClass( "sub-open open" );
				});

				$("#menu-primary > li > a").click(function(e){
					if( $(document).width() < 992  ){
						e.preventDefault();
					}
					var $this = $(this);
					var $menuItem = $this.closest( ".menu-item" );
					var $menu = $this.closest( "#menu-primary" );
					$menu.addClass( "sub-open" );
					$menuItem.addClass( "open" );
				});

				$("#menu-primary .sub-close a").click(function(e){
					$(this).closest(".open").removeClass("open");
					$(this).closest(".sub-open").removeClass("sub-open");
				});

				$(window).scroll(function(){
					var $window = $(this);
					var $header = $(".main-header").first();

					if( $window.scrollTop() > 0 ){
						$header.addClass("sticky");
					}else{
						$header.removeClass("sticky");
					}

					if( $window.scrollTop() < Sage.scrollTop ){
						$header.addClass("up");
					}else{
						$header.removeClass("up");
					}

					Sage.scrollTop = $window.scrollTop();
				});
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
				$(document).on('click', 'footer #footer-middle .menu-footer-menu-container>ul>li>a', function(){
					var parent = $(this).parent();
					if(parent.hasClass('open')){
						parent.removeClass('open');
					}else{
						$('footer #footer-middle .menu-footer-menu-container>ul>li.open').removeClass('open');
						parent.addClass('open');
					}
				});
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
		// Merci à vous page
    'merci_a_vous': {
      init: function() {
				$(document).ready(function(){
					msnry = new Masonry( '.donorContainer', {
						// set itemSelector so .grid-sizer is not used in layout
						itemSelector: '.bracket',
						// use element for option
						columnWidth: '.grid-sizer',
						percentPosition: true,
						horizontalOrder: true
				  });

					$('#carouselExampleIndicators').carousel();

					$.fn.hasAttr = function(name) {
					   return this.attr(name) !== undefined;
					};

					$(document).on('click', '.yearSlider .arrow', function(){
						var curYear = $('.yearSlider .curYear span.visible');
						var curHTML = parseInt(curYear.html());

						if($(this).hasClass('leftArrow') && curYear.hasAttr('data-prev')){
							fYear = $('.curYear span[data-year="'+ curYear.attr('data-prev') +'"]');

							if(fYear.length > 0){
								$('.curYear span.visible').removeClass('visible');
								fYear.addClass('visible');
								loadYear(curYear.attr('data-prev'));
								if(fYear.hasAttr('data-prev') === false){
									$('.arrow.leftArrow').addClass('nomore');
								}
								$('.arrow.rightArrow').removeClass('nomore');
							}
						}else if($(this).hasClass('rightArrow') && curYear.hasAttr('data-next')){
							fYear = $('.curYear span[data-year="'+ curYear.attr('data-next') +'"]');

							if(fYear.length > 0){
								$('.curYear span.visible').removeClass('visible');
								fYear.addClass('visible');
								loadYear(curYear.attr('data-next'));
								if(fYear.hasAttr('data-next') === false){
									$('.arrow.rightArrow').addClass('nomore');
								}
								$('.arrow.leftArrow').removeClass('nomore');
							}
						}
					});

					$(document).on('click', '.bracketLabel', function(){
						if ($(window).width() <= 768) {
							bracket = $(this).parent();
							people = bracket.find('ul.people');
							if(bracket.hasClass('open')){
								bracket.removeClass('open');
								people.slideUp();
							}else{
								bracket.addClass('open');
								people.slideDown();
							}
						}
					});
				});
      }
    },
		// Campagne Page
		'campagne_de_financement': {
      init: function() {
				function sticky_relocate() {
				  var window_top = $(window).scrollTop()+84;
				  var footer_top = $(".content-info").offset().top;
				  var div_top = $('.campagne-menu2').offset().top -10;
				  var div_height = $(".campagne-menu-list").height();

				  if (window_top + div_height > footer_top){
						$('.campagne-menu-list').removeClass('menu-fixed');
					} else if (window_top > div_top) {
				    $('.campagne-menu-list').addClass('menu-fixed');
				  } else {
				    $('.campagne-menu-list').removeClass('menu-fixed');
				  }
				}

				$(function () {
					$(window).scroll(sticky_relocate);
					sticky_relocate();
				});

				// $('#menu-anchor a').on('click', function(event) {
			  //   $(this).parent().parent().find('a').removeClass('active');
			  //   $(this).addClass('active');
				// });

				// $(window).on('scroll', function() {
			  //   $('.campagne-target').each(function() {
		    //     if($(window).scrollTop() >= $(this).offset().top)  {
	      //       var id = $(this).attr('id');
	      //       $('#menu-anchor a').removeClass('active');
	      //       $("#menu-anchor a[href=#"+ id +']').addClass('active');
		    //     }
			  //   });
				// });
      }
    },
    // ADN page
    'comite_adn': {
      init: function() {
				function sticky_relocate() {
				  var window_top = $(window).scrollTop()+84;
				  var footer_top = $(".content-info").offset().top;
				  var div_top = $('.campagne-menu2').offset().top -10;
				  var div_height = $(".campagne-menu-list").height();

				  if (window_top + div_height > footer_top){
						$('.campagne-menu-list').removeClass('menu-fixed');
					} else if (window_top > div_top) {
				    $('.campagne-menu-list').addClass('menu-fixed');
				  } else {
				    $('.campagne-menu-list').removeClass('menu-fixed');
				  }
				}

				$(function () {
					$(window).scroll(sticky_relocate);
					sticky_relocate();
				});

				$('#menu-anchor a').on('click', function(event) {
			    $(this).parent().parent().find('a').removeClass('active');
			    $(this).addClass('active');
				});

				$(window).on('scroll', function() {
			    $('.campagne-target').each(function() {
		        if($(window).scrollTop() >= $(this).offset().top)  {
	            var id = $(this).attr('id');
	            $('#menu-anchor a').removeClass('active');
	            $("#menu-anchor a[href=#"+ id +']').addClass('active');
		        }
			    });
				});
      }
    },
    // FAQ
    'page_template_faq': {
      init: function() {
        $(document).on('click', '.dropLabel', function(){
					if($(this).parent().hasClass('open') === true){
						$(this).parent().removeClass('open');
						$(this).parent().find('.dropContent').slideUp();
					}else{
						$(this).parent().addClass('open');
						$(this).parent().find('.dropContent').slideDown();
					}
				});
      }
    },
    // 'organisez_une_activite': {
    //   init: function() {
    //     $(document).on('click', '.dropLabel', function(){
		// 			if($(this).parent().hasClass('open') === true){
		// 				$(this).parent().removeClass('open');
		// 				$(this).parent().find('.dropContent').slideUp();
		// 			}else{
		// 				$(this).parent().addClass('open');
		// 				$(this).parent().find('.dropContent').slideDown();
		// 			}
		// 		});
    //   }
    // },
		// FAQ
    'page_template_clinique': {
      init: function() {

				$(document).ready(function(){
					$('#contactModal form .wpcf7-form-control-wrap').each(function(){
						var label = $(this).closest('.group').attr('data-label');
						$(this).append('<div class="highlight"></div><div class="bar"></div><label>'+ label +'</label>');
					});
					$(document).on("focus", ".wpcf7-form-control-wrap input", function(){
						$(this).closest('.group').addClass("input--filled");
					});

					$(document).on("focusout", ".wpcf7-form-control-wrap input", function(){
						if($(this).val().length === 0 ){
							$(this).closest('.group').removeClass("input--filled");
						}
					});
				});

        $(document).on('click', '.sidenav li a', function(){
					if($(this).parent().hasClass('open') !== true){
						$(this).closest('ul').find('li.open').removeClass('open');
						$(this).parent().addClass('open');
						$(this).closest('.row').find('.contentContainer .content.open').removeClass('open');
						$(this).closest('.row').find('.contentContainer .content[data-id="'+ $(this).attr('data-id') +'"]').addClass('open');
					}
				});

				$(document).on('click', 'ul.dropdown h4', function(){
					if($(this).parent().hasClass('open') !== true){
						$(this).parent().addClass('open');
						$(this).parent().find('.dropContent').slideDown();
					}else{
						$(this).parent().removeClass('open');
						$(this).parent().find('.dropContent').slideUp();
					}
				});

				$(document).on('click', '.mobileMenu > ul > li span', function(e){
					if($(this).parent().hasClass('open') === false){
						$('.mobileMenu > ul > li.open').removeClass('open');
						$(this).parent().addClass('open');
					}else{
						$('.mobileMenu > ul > li.open').removeClass('open');
					}
				});
				$(document).on('click', '.mobileMenu li.back', function(){
					$('.mobileMenu > ul > li.open').removeClass('open');
				});

				$(document).on('click', '.mobileMenu > ul > li li', function(){
					$('.mobileMenu > ul > li.open').removeClass('open');
					$('body').addClass('scrollable');
					// $("div.content[data-id='"+ $(this).attr('data-id') +"']").addClass('open');
					$('html, body').animate({
				    scrollTop: $("div.content[data-id='"+ $(this).attr('data-id') +"']").offset().top
					}, 1000);
					$('.mobileMenu').addClass('small');
				});

				$(document).on('click', '.mobileMenu.small', function(){
					$('.mobileMenu').removeClass('small');
					$('body').removeClass('scrollable');
				});
      }
    },
		// Réalisations Page
		'page_template_template_realisations': {
      init: function() {
				var columns = 7;
				var prevItem = "";
				function changeSlide(element){
					var name = element.attr('data-name');
					var largeimg = element.attr('data-largeimg');
					var quote = element.attr('data-quote');
					var description = element.attr('data-description');
					var theme = element.attr('data-theme');

					// var currentSlide = $('.smallSlider .selected');
					// var currentSlideIndex = currentSlide.index();
					// var newSlideIndex = element.index();
					// console.log("difference: " + (newSlideIndex - currentSlideIndex));

					$('.smallSlider .selected').removeClass('selected');
					element.addClass('selected');

					if(prevItem.length > 0){
						prevlargeimg = prevItem.attr('data-largeimg');
						$('.mainSlider').css('background', 'url('+ prevlargeimg +')center center / cover no-repeat');
						$('.tmpImg').hide();
						$('.tmpImg').css('background', 'url('+ largeimg +')center center / cover no-repeat');
						$('.tmpImg').fadeIn(200);
					}else{
						$('.mainSlider').css('background', 'url('+ largeimg +')center center / cover no-repeat');
						$('.tmpImg').css('background', 'url('+ largeimg +')center center / cover no-repeat');
					}

					if(theme == "dark"){
						$('.mainSlider .textContainer').addClass('dark');
					}else{
						$('.mainSlider .textContainer').removeClass('dark');
					}

					$('.mainSlider .name').html(name);
					$('.mainSlider .quote').html(quote);
					$('.mainSlider .description').html(description);
					prevItem = element;
				}

				function changeSliderCols(){
					if($(window).width() >= 992){
						// Extra Large
						columns = 7;
						itemID = 4;
					}else if ($(window).width() >= 768) {
						// Large
						columns = 7;
						itemID = 4;
					}else if ($(window).width() >= 576) {
						// Medium
						columns = 3;
						itemID = 2;
					}else if ($(window).width() >= 0) {
						// Small
						columns = 3;
						itemID = 2;
					}
					itemtosel = $('.people .miniPerson:nth-child('+ itemID +')');
					if(!itemtosel.hasClass('selected')){
						changeSlide(itemtosel);
					}
				}

				$(document).ready(function(){
					// changeSlide($('.miniPerson.selected'));
					changeSliderCols();
				});

				$(window).resize(function(){
					changeSliderCols();
				});

				var processingChecker = false;

				$(document).on('click', '.smallSlider .prevnext', function(){
					if( $(this).hasClass("previous") ){
						transitionSlide(1, 'left');
					}else{
						transitionSlide(1, 'right');
					}
				});

				function transitionSlide(amount, direction){
					// console.log("> amount: " + amount + " direction: " + direction);
					
					if (processingChecker) {
						return;
					}
					processingChecker = true;
					var currentSlide = $('.miniPerson.selected');
					var isPrevious = direction === 'left';

					var lessOrMore = isPrevious ? -1: 1;
					var amountMultiplier = amount * lessOrMore;
					
					var nextSlide = $('.miniPerson').eq(currentSlide.index() + amountMultiplier);

					if (nextSlide.length) {

							(function loopIntervals (n){

								if (n < amount) {
									var percentage = "-" + (100 / columns) + "%";
									$(".smallSlider .people").addClass("notransition");
									if (isPrevious) {
										if ( $('.people .miniPerson[data-personid="'+ $('.people .miniPerson:last-child').data('personid') +'"]').length === 1 ){
											$('.people').css("left", percentage).prepend($('.people .miniPerson:last-child').clone());
										}
									} else {
										if ( $('.people .miniPerson[data-personid="' + $('.people .miniPerson:first-child').data('personid') + '"]').length === 1 ) {
											$('.people').css("left", 0).append($('.people .miniPerson:first-child').clone());
										}
									}
									setTimeout(function () { // WAIT 30
										$(".smallSlider .people").removeClass("notransition");
										if (isPrevious) {
											$(".smallSlider .people").css("left", 0);
										} else {
											$(".smallSlider .people").css("left", percentage);
										}
										setTimeout(function () { // WAIT 140
											if (isPrevious) {
												$('.people .miniPerson:last-child').remove();
												$(".smallSlider .people").css("left", 0);
											} else {
												$(".smallSlider .people").addClass("notransition");
												$(".smallSlider .people").css("left", 0);
												$('.people .miniPerson:first-child').remove();
											}
											loopIntervals(n);
										}, 140);
									}, 30);
								}else{
									changeSlide(nextSlide);
									processingChecker = false;
								}
								n++;

							} (0));
					}
				}
				

				$(document).on('click', '.miniPerson', function(){
					if(!$(this).hasClass('selected')){
						var difference = Math.abs($(this).index() - $('.miniPerson.selected').index())
						if($(this).index() > $('.miniPerson.selected').index()){
							// Go Right
							transitionSlide(difference, 'right');
						}else{
							// Go Left
							transitionSlide(difference, 'left');
						}
						// changeSlide($(this));
					}
				});

				// Need to change this stuff
				$('.dropDownSelectors .selector').click(function () {
					if(!$(this).hasClass('active')){
						$('.dropDownSelectors .selector').removeClass('active');
						$(this).addClass('active');
						$('.dropDowns .dropDownSection').removeClass('active');
						$('.dropDowns .dropDownSection[data-selector="' + $(this).data('selector') +'"]').addClass('active');
						console.log($(this).data('selector'));
					}
				});
				// End of changes

      }
		},
		'page_template_contact': {
			init: function(){
				$(".wpcf7-form").find(".form-control").blur(function(e){
					if( $( this ).val() !== '' ){
						$(this).addClass("active");
					}else{
						$(this).removeClass("active");
					}
				});
			}
		}
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    },
    YTStateChange: function( e ) {
      var state = e.data;
      var player = e.target.d;
      if( state === 1 ){
        $(player).closest(".carousel").carousel("pause");
      }

      if( state === 0 ){
        $(player).closest(".carousel").carousel("cycle");
      }
		},
		YTReady: function( e ){
			var target = e.target;
			var player = e.target.d;
			$(player).siblings(".video-thumbnail").click(function(){
				$(this).fadeOut();
				target.playVideo();
			});
		},
		carousel_slid: function( e ) {
			// var parent = $( e.relatedTarget ).closest(".carousel");
			// if( e.direction === 'left' ){
			// 	parent.find(".carousel-item").first().detach();
			// 	parent.children( ".carousel-inner" ).removeClass("carousel-left");
			// }else{
			// 	parent.children( ".carousel-inner" ).prepend( parent.find(".carousel-item").last() );
			// }
			//parent.find(".carousel-indicators .active").removeClass("active");
		},
		carousel_slide: function( e ) {
			// var parent = $( e.relatedTarget ).closest(".carousel");
			// if( e.direction === 'left' ){
			// 	parent.children(".carousel-inner").append( parent.find(".carousel-item").first().clone() ).addClass("carousel-left");
			// }else{

			// }
			//parent.find(".carousel-indicators .active").removeClass("active");
		}
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery);

var YTdeferred = jQuery.Deferred();
window.onYouTubeIframeAPIReady = function(){
  YTdeferred.resolve(window.YT);
};

function openSearch() {
  // document.getElementById("searchBox").style.width = "100%";
  document.getElementById("searchBox").style.opacity = "1";
  document.getElementById("searchBox").style.height = "100%";
  document.getElementById("searchBox").classList.add("overlay-opacity");
}

function closeSearch() {
  // document.getElementById("searchBox").style.width = "0%";
  document.getElementById("searchBox").style.height = "0%";
  document.getElementById("searchBox").style.opacity = "0";
  document.getElementById("searchBox").classList.remove("overlay-opacity");
}


// Fully reference jQuery after this point.
